<template>
<div class="status-bar" aria-label="Site status">
    <div class="left">
        <span class="brand">{{ $state.siteDomain ? $state.siteDomain.toUpperCase() : 'ASORADAR' }}</span>
        <span class="clock" aria-hidden="true">{{ utc }}</span>
        <span class="version" aria-hidden="true">v{{ $state.version }}</span>
    </div>
    <div class="ticker" aria-hidden="true">
        <div class="track">
            <span>scanning [com.tinder]</span>
            <span>scanning [com.spotify]</span>
            <span>scanning [com.uber]</span>
            <span>scanning [com.airbnb]</span>
            <span>scanning [com.notion.id]</span>
            <span>scanning [com.figma.mirror]</span>
            <span>scanning [com.tinder]</span>
            <span>scanning [com.spotify]</span>
            <span>scanning [com.uber]</span>
            <span>scanning [com.airbnb]</span>
            <span>scanning [com.notion.id]</span>
            <span>scanning [com.figma.mirror]</span>
        </div>
    </div>
    <div class="chips">
        <button
            v-for="t in ['cyan','amber','phosphor']"
            :key="t"
            class="chip"
            :class="{ active: $state.theme === t }"
            :aria-pressed="$state.theme === t"
            :aria-label="`Switch theme to ${t}`"
            @click="$methods.setTheme(t)"
        >{{ t.toUpperCase() }}</button>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return { utc: '', _interval: null }
    },
    mounted() {
        const tick = () => {
            const d = new Date()
            this.utc = `T+${String(d.getUTCHours()).padStart(2,'0')}:${String(d.getUTCMinutes()).padStart(2,'0')}:${String(d.getUTCSeconds()).padStart(2,'0')} UTC`
        }
        tick()
        this._interval = setInterval(tick, 1000)
    },
    beforeUnmount() {
        if (this._interval) clearInterval(this._interval)
    },
}
</script>

<style scoped>
.status-bar {
    position: sticky;
    top: 0;
    z-index: 60;
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 24px;
    align-items: center;
    height: 32px;
    padding: 0 20px;
    background: #02040a;
    border-bottom: 1px solid var(--line);
    font-family: var(--font-mono);
    font-size: 11px;
    letter-spacing: 0.04em;
    color: var(--ink-mute);
    text-transform: uppercase;
}
.status-bar .left {
    display: flex;
    gap: 18px;
    align-items: center;
    white-space: nowrap;
}
.status-bar .brand {
    color: var(--ink);
    font-family: var(--font-display);
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 0.06em;
}
.status-bar .ticker {
    overflow: hidden;
    position: relative;
    height: 32px;
    display: flex;
    align-items: center;
    border-left: 1px solid var(--line);
    border-right: 1px solid var(--line);
    padding: 0 18px;
}
.status-bar .ticker .track {
    display: inline-flex;
    gap: 32px;
    animation: tick 60s linear infinite;
    white-space: nowrap;
}
.status-bar .ticker .track span {
    color: var(--ink-mute);
}
@keyframes tick {
    from { transform: translateX(0); }
    to { transform: translateX(-50%); }
}
.status-bar .chips {
    display: flex;
    gap: 0;
    height: 32px;
}
.chip {
    background: transparent;
    border: none;
    color: var(--ink-dim);
    font-family: var(--font-mono);
    font-size: 11px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    padding: 0 12px;
    height: 32px;
    cursor: pointer;
    transition: color 120ms;
}
.chip:not(:last-child)::after {
    content: '|';
    color: var(--line);
    margin-left: 12px;
    margin-right: -12px;
    pointer-events: none;
}
.chip:hover { color: var(--ink-mute); }
.chip.active { color: var(--accent); }
.chip:focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 2px;
}
@media (max-width: 768px) {
    .status-bar .ticker { display: none; }
}
@media (max-width: 480px) {
    .status-bar { height: 44px; }
    .status-bar .left { min-width: 0; }
    .status-bar .left .clock,
    .status-bar .left .version { display: none; }
    .status-bar .brand {
        max-width: 50vw;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .status-bar .ticker { height: 44px; }
    .status-bar .chips { height: 44px; }
    .chip { height: 44px; min-width: 44px; }
}
@media (max-width: 380px) {
    .status-bar { padding: 0 12px; gap: 8px; }
    .status-bar .brand {
        font-size: 12px;
        max-width: 110px;
    }
    .chip { padding: 0 8px; font-size: 10px; }
    .chip:not(:last-child)::after { margin-left: 8px; margin-right: -8px; }
}
@media (prefers-reduced-motion: reduce) {
    .status-bar .ticker .track { animation: none; }
}
</style>
